/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Franchise_SubtitleInputs */

const cs_franchise_subtitle = /** @type {(inputs: Franchise_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prodané licence a kanceláře pod značkou — jen metadata a agregace, nikdy data z jejich CRM`)
};

const en_franchise_subtitle = /** @type {(inputs: Franchise_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sold licenses and branded offices — metadata and aggregates only, never their CRM data`)
};

/**
* | output |
* | --- |
* | "Sold licenses and branded offices — metadata and aggregates only, never their CRM data" |
*
* @param {Franchise_SubtitleInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const franchise_subtitle = /** @type {((inputs?: Franchise_SubtitleInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Franchise_SubtitleInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_franchise_subtitle(inputs)
	return cs_franchise_subtitle(inputs)
});